// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"3e6ad831","271":"c0165587"}[chunkId] + ".chunk.js";
};